import React, { createContext, useContext, useMemo } from 'react';
import {
  fetchSnapshot,
  fetchStatus,
  syncProducts,
  syncOrders,
} from '../services/stockDharma/proxy';

/**
 * Shares the read-only Stock Dharma proxy services with the portal.
 *
 * Stock Dharma credentials live on the SIMS server. Nothing here signs in,
 * stores a Stock Dharma session, or receives an upstream token, so cashiers
 * and managers see data without any Stock Dharma account.
 */
const StockDharmaContext = createContext(null);

export const useStockDharma = () => {
  const context = useContext(StockDharmaContext);
  if (!context) {
    throw new Error('useStockDharma must be used within a StockDharmaProvider');
  }
  return context;
};

export function StockDharmaProvider({ children }) {
  const services = useMemo(
    () => ({
      dashboard: { getSnapshot: fetchSnapshot },
      getStatus: fetchStatus,
      syncCatalog: syncProducts,
      syncOrders: syncOrders,
    }),
    [],
  );

  const value = useMemo(() => ({ services }), [services]);

  return (
    <StockDharmaContext.Provider value={value}>
      {children}
    </StockDharmaContext.Provider>
  );
}

export default StockDharmaContext;
